import React, { useMemo } from 'react';

import { observer } from 'mobx-react-lite';

import {
  TablePopUpContainer,
  TableConnectionPopupsWr,
  PlatformMessagesWrapper,
  PostMessageListenerMessages,
  applicationStore,
  useTranslation,
  popupStore,
  GameLaunchManager,
  UnderMaintenanceContainer,
  gameConfigStore,
  loadingStore,
  LoadingContainer,
} from '@pascal/pascal-core';
import { PopUps } from '@pascal/pascal-core/table-line/t_types/enums/PopupTypes';

import { FactoryRouter } from './factoryRouter';
import { HelpPopup } from '../components/helpPopup';
import { SocketConnection } from './socketConnection';
import { FairnessPopup } from '../components/fairnessPopup';
import { CheckHashPopup } from '../components/checkHashPop';
import { translationKeys } from '../enums/translations';
import { socketEventsHandlerDelays } from '../enums/uiConfig';
import { gameLiveConnection } from '../services';
import { AppDefaultValuesEnum } from '../enums/appDefaultValues';
import { defaultLanguageNameDependGameIds } from '../enums/gameConstant';
import { gameDrawer } from '../game/drawers/gameDrawer';

export const Factory = observer(({ components }) => {
  const t = useTranslation();
  const { gameIsOpen } = applicationStore;
  const { popupToggle, popupName } = popupStore;
  const { gameId } = gameConfigStore;

  const popupMap = useMemo(
    () => ({
      [PopUps.Fairness]: {
        component: FairnessPopup,
        title: t(translationKeys.Fairness),
      },
      [PopUps.CheckHash]: {
        component: CheckHashPopup,
        title: t(translationKeys.Check),
      },
      [PopUps.Reconnect]: {
        component: TableConnectionPopupsWr,
        title: t(translationKeys.Reconnect),
      },
      [PopUps.ConnectionError]: {
        component: TableConnectionPopupsWr,
        title: t(translationKeys.ConnectionError),
      },
      [PopUps.GameOpen]: {
        component: TableConnectionPopupsWr,
        title: t(translationKeys.GameOpen),
      },
      [PopUps.Help]: {
        component: HelpPopup,
        title: t(translationKeys.Help),
      },
    }),
    [t]
  );
  const defaultLanguageFileNameDependOnGameId = useMemo(() => {
    return defaultLanguageNameDependGameIds[gameId];
  }, [gameId]);

  const repliedCallback = () => {
    gameDrawer
      .execute({
        mode: 'web',
        scene: 'Main',
        prevScene: null,
      })
      .then(() => {
        loadingStore.updateLoading({ isPixiLoaded: true });
      });
  };

  return (
    <UnderMaintenanceContainer>
      <LoadingContainer
        appDefaultValuesEnum={AppDefaultValuesEnum}
        defaultLanguageName={defaultLanguageFileNameDependOnGameId}
        gameSpecificRepliedCallback={repliedCallback}
      >
        <PlatformMessagesWrapper
          additionalMessagesParams={[
            {
              name: PostMessageListenerMessages.UpdateBalance,
              callback: () => {
                gameLiveConnection.getBalance();
              },
            },
          ]}
        >
          <GameLaunchManager
            socketEventsHandlerDelays={socketEventsHandlerDelays}
            GameContainer={<FactoryRouter components={components} />}
            SocketConnectionWr={
              <SocketConnection>
                <FactoryRouter components={components} />
              </SocketConnection>
            }
          />
        </PlatformMessagesWrapper>
        {(popupToggle || gameIsOpen) && (
          <TablePopUpContainer popupMap={popupMap} popUpName={popupName} gameIsOpen={gameIsOpen} />
        )}
      </LoadingContainer>
    </UnderMaintenanceContainer>
  );
});
